import React, { useEffect, createRef } from "react";
import { NavLink } from "react-router-dom";
import { gsap } from "gsap";

const HeaderBar = ({ delay, title = "Winning Star Guessing" }) => {
  useEffect(() => {
    gsap
      .fromTo(
        headerRef.current,
        {
          y: "-20vh",
        },
        {
          y: 0,
          duration: 1,
        }
      )
      .delay(delay || 4);
  }, []);

  const headerRef = createRef();

  return (
    <div ref={headerRef} className="headerBar">
      <NavLink to="/" className="brandName">
        {title}
      </NavLink>
      <div style={{ display: "flex" }}>
        <NavLink
          className="navLinks"
          activeClassName="activeLink"
          to="/dashboard"
          exact
        >
          Dashboard
        </NavLink>

        <NavLink
          className="navLinks"
          activeClassName="activeLink"
          to="/services"
          exact
        >
          Services
        </NavLink>

        <NavLink
          className="navLinks"
          activeClassName="activeLink"
          to="/download"
          exact
        >
          Download
        </NavLink>
      </div>
    </div>
  );
};

export default HeaderBar;
